export enum WageSide {
    merchant = 0,
    payer = 1,
    payerJustShaparakWage = 2,
    payerJustMerchantWage = 3
}